export const SOCIAL_LIST = [
  {
    key: "email",
    label: "EMAIL",
    href: "mailto:contact@cowork.dev",
  },
  {
    key: "linkedin",
    label: "LINKEDIN",
    href: "https://www.linkedin.com/company/cowork-dev",
  },
  {
    key: "facebook",
    label: "FACEBOOK",
    href: "https://www.facebook.com/cowork.dev",
  },
];

export const CONTACT_SERVICE_LIST = [
  {
    key: "frontend",
    label: "FRONTEND",
  },
  {
    key: "backend",
    label: "BACKEND",
  },
  {
    key: "mobile",
    label: "MOBILE",
  },
  {
    key: "design",
    label: "DESIGN",
  },
  {
    key: "testing",
    label: "TESTING",
  },
];

export const INITFORM_LIST = [
  {
    text: "",
    key: "companyName",
    label: "Company*",
    error: false,
    errorText: "Please type your company's name",
  },
  {
    text: "",
    key: "email",
    label: "Email*",
    error: false,
    errorText: "Please type your Email",
  },
  {
    text: "",
    key: "phoneNumber",
    label: "Phone*",
    error: false,
    errorText: "Please type your phone number",
  },
];

export const PORTFOLIO_LIST = [
  {
    key: "name",
    placeholder: "Title",
  },
  {
    key: "company_age",
    placeholder: "Company coorperation",
  },
  {
    key: "location",
    placeholder: "Location",
  },
  {
    key: "business",
    placeholder: "Business",
  },
  {
    key: "services",
    placeholder: "Services",
  },
  {
    key: "social_link",
    placeholder: "Social Link",
  },
  {
    key: "description",
    placeholder: "Description",
  },
];
